import React from 'react';
import { useRouter } from 'next/router';
import { X } from 'lucide-react';
import { ModalProps } from '@/hooks/useModal';
import { Button, Icon, Typography } from '@/components/common';
import Icons from '@/const/icons';
import AppRoutes from '@/const/routes';

interface Props {
	Modal: React.FC<ModalProps>;
	onClose: () => void;
}

export const FindCaseModal: React.FC<Props> = ({ Modal, onClose }) => {
	const router = useRouter();

	const handleExploreAllCases = () => {
		onClose();
		router.push(AppRoutes.CLIENTAPP_ALL_CASES);
	};

	return (
		<Modal
			avoidClose
			classNameCardContainer="!w-full md:!w-[730px] md:!max-w-[730px] !p-0 !rounded-[24px] !shadow-2xl bg-white"
			classNameContainerChildren="!max-h-none"
			noMaxHeight
		>
			<div className="relative flex flex-col items-center text-center px-8 py-10">
				<button
					type="button"
					onClick={onClose}
					className="absolute right-6 top-6 outline-none"
				>
					<X className="w-6 h-6 text-black" />
				</button>

				<div className="flex items-center justify-center gap-1 mb-8">
					<Typography type="bold-28" className="!text-black">
						Welcome to
					</Typography>
					<Typography type="bold-28" className="!text-primary">
						Claim Magic
					</Typography>
				</div>

				<div className="w-[138px] h-[138px] mx-auto mb-8">
					<Icon src={Icons.findCase} className="w-full h-full" />
				</div>

				<Typography type="bold-36" className="!text-2xl xl:!text-[32px]">
					Find a Case to Get Started
				</Typography>

				<Typography type="regular-18" className="mx-auto mt-8">
					Welcome to Claim Magic! To begin, explore our active cases and see if
					you qualify for a claim or legal settlement.
				</Typography>

				<div className="flex items-center justify-center mt-10">
					<Button
						decoration="primary"
						size="fit"
						onClick={handleExploreAllCases}
					>
						Explore All Cases
					</Button>
				</div>
			</div>
		</Modal>
	);
};
